import gql from 'graphql-tag'

const query = gql`
  query getProfile {
    auth {
      getProfile {
        userID
        userName
        id
        isPublic
        enabled
        location
        phone
        mustChangePwd
        authProvider
        departement
        registerno
        apiurl
        userAccess {
          roleID
          roleName
          roleType
          permission
          permissionMenu
        }
        userOrg {
          orgID
          orgCode
          orgName
          parentOrgID
          parentOrgCode
          parentOrgName
          prodOrg {
            prodID
            prodName
            prodPath
          }
        }
        userProd {
          prodID
          prodName
          prodPath
        }
      }
    }
  }
`

export default query
